import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ReactNode, type HTMLAttributes } from 'react';
import styles from './Card.module.scss';
export type CardPadding = 'sm' | 'md' | 'lg' | 'none';
export type CardSurface = 'transparent' | 'subtle';
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  fullHeight?: boolean;
  padded?: CardPadding;
  mobilePadded?: CardPadding;
  /** `subtle` is the redesign card's panel; `transparent` (default) draws none. */
  surface?: CardSurface;
  children: ReactNode;
}
function Card(t0) {
  const $ = _c(18);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      fullHeight: t1,
      padded: t2,
      mobilePadded: t3,
      surface: t4,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const fullHeight = t1 === undefined ? false : t1;
  const padded = t2 === undefined ? "none" : t2;
  const mobilePadded = t3 === undefined ? "none" : t3;
  const surface = t4 === undefined ? "transparent" : t4;
  let t5;
  if ($[8] !== className || $[9] !== fullHeight || $[10] !== mobilePadded || $[11] !== padded || $[12] !== surface) {
    t5 = classNames(styles["helios-card"], {
      [styles["helios-card--full-height"]]: fullHeight
    }, styles[`helios-card--surface-${surface}`], padded !== "none" && styles[`helios-card--padded-${padded}`], mobilePadded !== "none" && styles[`helios-card--mobile-padded-${mobilePadded}`], className);
    $[8] = className;
    $[9] = fullHeight;
    $[10] = mobilePadded;
    $[11] = padded;
    $[12] = surface;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== children || $[15] !== props || $[16] !== t5) {
    t6 = <div className={t5} {...props}>{children}</div>;
    $[14] = children;
    $[15] = props;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
export default Card;